import CloudOffIcon from '@material-ui/icons/CloudOff';
import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef } from './routes';
import { externalDownDetectorApi } from './apis';

// The page renders its own core-components Page/Header (title plus the vendor
// subtitle), so the framework header is off to avoid a second one. Moving to
// the framework/BUI header belongs to the MUI→BUI track.
const externalDownDetectorPage = PageBlueprint.make({
  params: {
    path: '/external-down-detector',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/ExternalDownDetectorPage/ExternalDownDetectorPage').then(
        m => <m.ExternalDownDetectorPage />,
      ),
  },
});

export default createFrontendPlugin({
  pluginId: 'external-down-detector',
  title: 'External Down Detector',
  icon: <CloudOffIcon fontSize="inherit" />,
  info: { packageJson: () => import('../package.json') },
  routes: { root: rootRouteRef },
  extensions: [externalDownDetectorApi, externalDownDetectorPage],
});
